<div class="property-match-options-container" [ngClass]="{ horizontal: horizontal() }">
  <!-- Liked Me -->
  <div class="match-option" [ngClass]="{ 'active-pink': likedMeSelected() }" (click)="toggleOption(MATCH_OPTIONS.LIKED_ME)">
    <div class="flex items-center">
      <div class="match-option__icon pink">
        <sxw-svg-icon strokeColor="#db2777" name="heart" width="19" height="19"></sxw-svg-icon>
      </div>
      <div class="flex-grow-1">
        <span class="match-option__title">{{ "filters.likedMe.title" | translate }}</span>
        <p class="match-option__description">{{ "filters.likedMe.description" | translate }}</p>
      </div>
      <div class="match-option__checkbox">
        <sxw-checkbox-input size="small" class="custom-checkbox" [value]="likedMeSelected()"></sxw-checkbox-input>
      </div>
    </div>
  </div>

  <!-- Mutual Interest -->
  <div class="match-option" [ngClass]="{ 'active-purple': mutualInterestSelected() }" (click)="toggleOption(MATCH_OPTIONS.MUTUAL_INTEREST)">
    <div class="flex items-center">
      <div class="match-option__icon purple">
        <sxw-svg-icon strokeColor="#9333ea" name="mutualInterest" width="20" height="20"></sxw-svg-icon>
      </div>
      <div class="flex-grow-1">
        <span class="match-option__title">{{ "filters.mutualInterest.title" | translate }}</span>
        <p class="match-option__description">{{ "filters.mutualInterest.description" | translate }}</p>
      </div>
      <div class="match-option__checkbox">
        <sxw-checkbox-input size="small" class="custom-checkbox" [value]="mutualInterestSelected()"></sxw-checkbox-input>
      </div>
    </div>
  </div>

  <!-- Best Match -->
  <div class="match-option" [ngClass]="{ 'active-green': bestMatchSelected() }" (click)="toggleOption(MATCH_OPTIONS.BEST_MATCH)">
    <div class="flex items-center">
      <div class="match-option__icon green">
        <sxw-svg-icon strokeColor="#16a34a" name="bestMatch" width="20" height="20"></sxw-svg-icon>
      </div>
      <div class="flex-grow-1">
        <span class="match-option__title">{{ "filters.bestMatch.title" | translate }}</span>
        <p class="match-option__description">{{ "filters.bestMatch.description" | translate }}</p>
      </div>
      <div class="match-option__checkbox">
        <sxw-checkbox-input size="small" class="custom-checkbox" [value]="bestMatchSelected()"></sxw-checkbox-input>
      </div>
    </div>
  </div>
</div>
